if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.targetId);
        this.priceSource = document.getElementById(this.dataset.priceSourceId);
        this.submitButton = this.querySelector('[data-sticky-submit]');
        this.priceDestination = this.querySelector('[data-sticky-price]');
        this.labelDestination = this.querySelector('[data-sticky-label]');

        if (!this.target) return;

        this.submitButton.addEventListener('click', () => {
          this.target.click();
        });

        this.observeVisibility();
        this.observeState();
      }

      observeVisibility() {
        const observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.hidden = !scrolledPast;
          },
          { threshold: 0 }
        );
        observer.observe(this.target);
      }

      observeState() {
        const syncState = () => {
          this.submitButton.disabled = this.target.disabled;
          if (this.labelDestination) {
            const label = this.target.querySelector('span:not(.sold-out-message):not(.loading-overlay__spinner)');
            if (label) this.labelDestination.textContent = label.textContent.trim();
          }
        };

        syncState();

        new MutationObserver(syncState).observe(this.target, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        if (this.priceSource && this.priceDestination) {
          const syncPrice = () => {
            this.priceDestination.innerHTML = this.priceSource.innerHTML;
          };
          syncPrice();
          new MutationObserver(syncPrice).observe(this.priceSource, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      }
    }
  );
}
